<template>
    <div class="modal fade" id="m_modal_addProduct" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{ labels[triggers[name].title] }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h5>{{ labels[triggers[name].subtitle1] }}</h5>
                    <input type="text" v-model="searchValue">
                    <br>
                    <span><em>{{ matches }}</em> {{ labels['products_matching_this_search'] }}</span>
                    <div v-for="product in productHits">{{ product.name }}
                        <router-link :to="{ name: 'ProductForm', query: { productId: product.productId }}" data-dismiss="modal">
                            <i class="flaticon-visible"></i>
                        </router-link>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ labels['cancel'] }}</button>
                    <button type="button" class="btn btn-primary" @click="submitAction" data-dismiss="modal">{{ labels[triggers[name].buttonText] }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as algoliasearch from 'algoliasearch'

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_KEY);
const productIndex = client.initIndex(process.env.ENV_SHORTNAME + '_products')

export default {
    props: ['name'],
    data () {
        return {
            search: '',
            matches: 0,
            productHits: [],
            // Object of trigger values and their redirect urls, message-text, etc
            triggers: {
                addProduct: {
                    url: '/dashboard/manage-stock/product',
                    title: 'add_a_new_product',
                    subtitle1: 'product_already_in_cip',
                    subtitle2: 'new_cip_product',
                    actions: 'searchForProduct',
                    buttonText: 'add_a_new_product'
                }
            },
            csvFile: null
        }
    },
    computed: {
        ...mapState([
            'labels'
        ]),
        searchValue: {
            get () {
                return this.search
            },
            set (value) {
                this.search = value
                // Send search request
                if (value) {
                    this.searchForProduct(value)
                }
            }
        }
    },
    methods: {
        ...mapActions([
            'toggleModal'
        ]),
        submitAction () {
            var url = this.triggers[this.name].url
            this.$router.push(url)
        },
        searchForProduct (value) {
            let my = this
            productIndex.search(
                {
                    query: value,
                    hitsPerPage: 3
                },
                function searchDone (err, content) {
                    if (err) throw err
                    // Update product results
                    my.matches = content.nbHits
                    my.productHits = content.hits
                }
            )
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/Modal.vue